import { render, staticRenderFns } from "./SettingsLogo.vue?vue&type=template&id=d910ace8&"
import script from "./SettingsLogo.vue?vue&type=script&lang=js&"
export * from "./SettingsLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports